const dimensions = {
  desktopSidePadding: 120,
  bottomDrawerTopSpace: 80,
};
export default dimensions;
